import { removeEmptyProps } from '../../utils/helpers.mjs';
import 'react';

const BOX_STYLE_PROPS_DATA = {
  margin: { type: "spacing", property: "margin" },
  marginTop: { type: "spacing", property: "marginTop" },
  marginBottom: { type: "spacing", property: "marginBottom" },
  marginLeft: { type: "spacing", property: "marginLeft" },
  marginRight: { type: "spacing", property: "marginRight" },
  marginInlineStart: { type: "spacing", property: "marginInlineStart" },
  marginInlineEnd: { type: "spacing", property: "marginInlineEnd" },
  marginInline: { type: "spacing", property: "marginInline" },
  marginBlock: { type: "spacing", property: "marginBlock" },
  padding: { type: "spacing", property: "padding" },
  paddingTop: { type: "spacing", property: "paddingTop" },
  paddingBottom: { type: "spacing", property: "paddingBottom" },
  paddingLeft: { type: "spacing", property: "paddingLeft" },
  paddingRight: { type: "spacing", property: "paddingRight" },
  paddingInlineStart: { type: "spacing", property: "paddingInlineStart" },
  paddingInlineEnd: { type: "spacing", property: "paddingInlineEnd" },
  paddingInline: { type: "spacing", property: "paddingInline" },
  paddingBlock: { type: "spacing", property: "paddingBlock" },
  backgroundColor: { type: "color", property: "background" },
  textColor: { type: "textColor", property: "color" },
  opacity: { type: "identity", property: "opacity" },
  width: { type: "spacing", property: "width" },
  minWidth: { type: "spacing", property: "minWidth" },
  maxWidth: { type: "spacing", property: "maxWidth" },
  height: { type: "spacing", property: "height" },
  minHeight: { type: "spacing", property: "minHeight" },
  maxHeight: { type: "spacing", property: "maxHeight" },
  fontFamily: { type: "fontFamily", property: "fontFamily" },
  fontSize: { type: "fontSize", property: "fontSize" },
  fontWeight: { type: "identity", property: "fontWeight" },
  letterSpacing: { type: "size", property: "letterSpacing" },
  textAlign: { type: "identity", property: "textAlign" },
  lineHeight: { type: "lineHeight", property: "lineHeight" },
  fontStyle: { type: "identity", property: "fontStyle" },
  textTransform: { type: "identity", property: "textTransform" },
  textDecoration: { type: "identity", property: "textDecoration" },
  position: { type: "identity", property: "position" },
  display: { type: "identity", property: "display" },
  objectFit: { type: "identity", property: "objectFit" },
  objectPosition: { type: "identity", property: "objectPosition" },
  zIndex: { type: "identity", property: "zIndex" },
  left: { type: "spacing", property: "left" },
  right: { type: "spacing", property: "right" },
  top: { type: "spacing", property: "top" },
  bottom: { type: "spacing", property: "bottom" },
  border: { type: "identity", property: "border" },
  borderTop: { type: "identity", property: "borderTop" },
  borderBottom: { type: "identity", property: "borderBottom" },
  borderRight: { type: "identity", property: "borderRight" },
  borderLeft: { type: "identity", property: "borderLeft" },
  borderRadius: { type: "identity", property: "borderRadius" }
};
function extractStyleProps(others) {
  const {
    margin,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    marginInlineStart,
    marginInlineEnd,
    marginInline,
    marginBlock,
    padding,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingInlineStart,
    paddingInlineEnd,
    paddingInline,
    paddingBlock,
    opacity,
    width,
    minWidth,
    maxWidth,
    height,
    minHeight,
    maxHeight,
    display,
    textColor,
    backgroundColor,
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    textAlign,
    textTransform,
    position,
    lineHeight,
    fontStyle,
    textDecoration,
    objectFit,
    objectPosition,
    zIndex,
    left,
    right,
    top,
    bottom,
    border,
    borderRight,
    borderTop,
    borderLeft,
    borderBottom,
    borderRadius,
    ...rest
  } = others;
  const styleProps = removeEmptyProps({
    margin,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    marginInlineStart,
    marginInlineEnd,
    marginInline,
    marginBlock,
    padding,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingInlineStart,
    paddingInlineEnd,
    paddingInline,
    paddingBlock,
    opacity,
    width,
    minWidth,
    maxWidth,
    height,
    minHeight,
    maxHeight,
    display,
    textColor,
    backgroundColor,
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    textAlign,
    textTransform,
    position,
    lineHeight,
    fontStyle,
    textDecoration,
    objectFit,
    objectPosition,
    zIndex,
    left,
    right,
    top,
    bottom,
    border,
    borderRight,
    borderTop,
    borderLeft,
    borderBottom,
    borderRadius
  });
  return { styleProps, rest };
}

export { BOX_STYLE_PROPS_DATA, extractStyleProps };
